import { gsap, SplitText } from "@gsap";

/*
 * Hover van alle knoppen: de tekst rolt omhoog en een kopie komt van onderen binnen (zoals OneLane). De kleur verandert niet.
 * Alleen .pk-button-text wordt omgebouwd, zodat het icoon blijft staan. Een knop in een link (bijvoorbeeld een kaart) reageert op de hover van die link.
 */

if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
	const TIMING = {
		in: { duration: 0.45, ease: "power3.inOut", stagger: 0.05 },
		out: { duration: 0.4, ease: "power2.out", stagger: 0.15 },
	};

	// Per knop: de gesplitste woorden en de lopende animatie. De omvorming gebeurt bij de eerste hover, als het lettertype al geladen is.
	const states = new WeakMap();

	const build = (button) => {
		const label = button.querySelector(".pk-button-text");
		const text = label?.textContent.trim();
		if (!label || !text || label.hasAttribute("data-text-wrapper")) return null;

		const original = document.createElement("span");
		original.setAttribute("data-text-original", "");
		original.textContent = text;

		const double = document.createElement("span");
		double.setAttribute("data-text-double", "");
		double.setAttribute("aria-hidden", "true");
		double.textContent = text;

		label.setAttribute("data-text-wrapper", "");
		label.textContent = "";
		label.append(original, double);

		const state = {
			original: new SplitText(original, { type: "words", mask: "words" }),
			double: new SplitText(double, { type: "words", mask: "words" }),
			tween: null,
		};

		gsap.set(state.original.words, { yPercent: 0 });
		gsap.set(state.double.words, { yPercent: 100 });

		return state;
	};

	const play = (button, originalY, doubleY, timing) => {
		if (!states.has(button)) states.set(button, build(button));

		const state = states.get(button);
		if (!state) return;

		state.tween?.kill();
		state.tween = gsap
			.timeline()
			.to(state.original.words, { yPercent: originalY, duration: timing.duration, ease: timing.ease, stagger: { amount: timing.stagger } })
			.to(state.double.words, { yPercent: doubleY, duration: timing.duration, ease: timing.ease, stagger: { amount: TIMING.out.stagger } }, "<");
	};

	const buttonsOf = (link) => (link.matches(".pk-button") ? [link] : [...link.querySelectorAll(".pk-button")]);

	const handle = (event, originalY, doubleY, timing) => {
		const link = event.target.closest?.("a, button");
		if (!link || link.dataset.animate === "none" || link.contains(event.relatedTarget)) return;

		buttonsOf(link).forEach((button) => play(button, originalY, doubleY, timing));
	};

	document.addEventListener("mouseover", (event) => handle(event, -100, 0, TIMING.in));
	document.addEventListener("mouseout", (event) => handle(event, 0, 100, TIMING.out));
	document.addEventListener("focusin", (event) => handle(event, -100, 0, TIMING.in));
	document.addEventListener("focusout", (event) => handle(event, 0, 100, TIMING.out));
}
